import React, { Component } from 'react'
import { connect} from 'react-redux'
import { explodeString } from "../../utilities";
import './style.css'

class Banner extends Component {
    render() {
        const where = explodeString(this.props.poster.field_where);
        
        return (
            <div
                id="view-banner"
                className="banner"
                style={{
                "--fontRatio": this.props.poster.fontRatio,
                }}
            >
                <img
                src={require(`../../images/banner/${this.props.poster.field_type}/${this.props.poster.field_color}.jpg`)}
                alt={`Banner background in style ${this.props.poster.field_type} and color ${this.props.poster.field_color}`}
                className="banner-image"
                />

                <div className="banner-wrapper">
                <div className="heading banner-heading" id="heading">
                    <span
                    className="calc"
                    dangerouslySetInnerHTML={{ __html: where }}
                    ></span>
                </div>
                </div>
            </div>
            );
        
    }
}

const mapStateToProps = (state) => {
    return {
        poster: state.poster
    }
}

export default connect(mapStateToProps)(Banner)